// extracted by mini-css-extract-plugin
export default {"vas-option__title":"styles_vas-option__title__TWiRH","vas-option__content":"styles_vas-option__content__pYTcw"};